<template>
  <section>
    <div class="container myaccountfullPage">
      <div class="row">
        <div class="col-md-8 col-sm-8 col-xs-12">
          <div v-if="stocksList && stocksList.length">
            <div class="row">
              <p class="pull-right subheading mr-3">{{ userPlan.stocks - stocksList.length }} of {{ userPlan.stocks }} stocks remaining</p>
            </div>
            <div class="row">
              <div
                class="col-md-4 col-sm-6 col-xs-12"
                v-for="(stock, index) in stocksList"
                :key="stock.id"
              >
                <div class="stock_card mb-4 elevation-3">
                  <div class="pa-3">
                    <h4 class="mt-3"><span> {{index + 1}}. </span> {{ stock.name }} <a
                        v-if="stock.update.length"
                        class="pull-right"
                        @click="currentStock = stock; dialog = true;"
                      >
                        <i class="fas fa-bell"></i>
                      </a></h4>
                    <p>{{stock.description}}</p>
                    <p><strong>ISIN Code :</strong> {{ stock.code}}</p>
                    <p v-if="stock.bseCode"><strong>BSE Code :</strong>{{ stock.bseCode }}</p>
                    <p v-if="stock.nseCode"><strong>NSE Code :</strong>{{ stock.nseCode }}</p>

                    <a
                      v-show="stock.reportLink"
                      :href="stock.reportLink"
                      class="mt-3 download_report"
                      target="_blank"
                      download
                    >
                      <i
                        class="fas fa-cloud-download-alt"
                        :href="stock.reportLink"
                      ></i> Download Full Report </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="noActiveSubscription">
            <h2 class="text-xs-center heading">Start your Investment journey with GROW WITH STOCKS</h2>
            <h5 class="text-xs-center mt-4">Choose your subscription to start receiving monthly stocks, reports and advisory services</h5>
            <div class="row">
              <div class="col-md-6 col-md-offset-3 col-sm-6 col-sm-6 col-sm-offset-3 col-xs-12">
                <router-link
                  to="/pricing#pricing_section"
                  tag="button"
                  class="btn-pricing pa-3"
                >Plans &amp; Pricing</router-link>
              </div>
            </div>
          </div>
          <div v-if=" stocksList && !stocksList.length && userPlan && userPlan.stocks">
            <h2 class="heading text-xs-center">
              Your subscription will be started soon and your {{ userPlan.stocks }} stocks will be displayed here.
            </h2>
            <p class="text-xs-center"> In case you need any further support, email us at <a>info@growwithstocks.com </a></p>
          </div>
        </div>

        <div class="col-md-3 col-sm-4 col-md-offset-1 col-xs-12">
          <div class="row mt-2">
            <div class="col-md-4 col-xs-6 subheading">Name</div>
            <div class="col-md-8 col-xs-6">{{ user.first_name}} {{ user.last_name}}</div>
          </div>
          <div class="row mt-2">
            <div class="col-md-4 col-xs-6 subheading">Email</div>
            <div class="col-md-8 col-xs-6">{{ user.email }}</div>
          </div>
          <div class="row mt-2">
            <div class="col-md-4 col-xs-6 subheading">Phone</div>
            <div class="col-md-8 col-xs-6">{{ user.phone }}</div>
          </div>
          <div class="row mt-2">
            <div class="col-md-8 col-xs-6">
              <a @click="openChangePassword = true">
                Change Password
              </a>
            </div>
          </div>
          <button
            class="pa-3 mt-5"
            @click="logout"
          >Logout</button>
        </div>
      </div>
      <v-dialog
        v-model="openChangePassword"
        width="500"
      >
        <v-card class="pa-4">
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
            Change Password
          </v-card-title>
          <form v-on:submit.prevent>
            <v-text-field
              v-model="password"
              type="password"
              color="black"
              label="Old Password"
              hint="At least 8 characters"
              required
            ></v-text-field>
            <v-text-field
              v-model="newPassword"
              type="password"
              color="black"
              label="New Password"
              hint="At least 8 characters"
              required
            ></v-text-field>
            <v-text-field
              v-model="confirmNewPassword"
              type="password"
              color="black"
              label="Confirm New Password"
              hint="At least 8 characters"
              required
            ></v-text-field>
          </form>

          <v-card-actions>
            <v-spacer></v-spacer>
            <button
              class="btn btn_custom"
              @click="changePassword"
            >
              <i class="fas fa-check mr-4"></i>
              Confirm
            </button>
            <button
              class="btn btn_custom ml-1"
              @click="openChangePassword = false"
            >
              <i class="fas fa-ban mr-4"></i>
              Cancel
            </button>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Updates Popup -->
      <v-dialog
        v-model="dialog"
        scrollable
        max-width="600px"
      >
        <v-card
          v-if="currentStock"
          class="pa-3"
        >
          <h4><strong> Updates for {{ currentStock.name }} </strong></h4>
          <v-divider></v-divider>
          <div class="row mb-3">
            <div class="col-xs-3">
              <strong>
                Date
              </strong>
            </div>
            <div class="col-xs-2">
              <strong>
                Action
              </strong>
            </div>
            <div class="col-xs-5">
              <strong>
                Description
              </strong>
            </div>
            <div class="col-xs-2">
              <strong>
                Report
              </strong>
            </div>
          </div>
          <div
            class="row"
            v-for="
            item
            in
            currentStock.update"
            :key="item.id"
          >
            <div class="col-xs-3">
              {{ beautifyDate(item.createdAt) }}
            </div>
            <div
              class="col-xs-2 font-weight-bold"
              :class="{'false' : item.type === 'Sell', 'true' : item.type === 'Buy'}"
            > {{item.type}}</div>
            <div class="col-xs-5">
              {{item.description}}
            </div>
            <div class="col-xs-2">
              <a
                class="text-md-center ml-3"
                target="_blank"
                download
                :href="item.report_link"
              >
                <i class="fas fa-cloud-download-alt"></i></a>
            </div>
          </div>
          <v-divider></v-divider>
          <a
            class="know_more_link text-md-center pb-3"
            @click="dialog = false"
          >Close</a>
        </v-card>
      </v-dialog>
      <!-- Updates Popup -->
    </div>
  </section>
</template>

<script>
  import { mapGetters } from "vuex";
  import lb from "../util/lb";

  export default {
    name: "MyAccount",
    computed: {
      ...mapGetters(["user"])
    },
    data() {
      return {
        password: null,
        newPassword: null,
        confirmNewPassword: null,
        openChangePassword: false,
        stocksList: [],
        userPlan: {},
        currentStock: null,
        dialog: false,
        noActiveSubscription: true
      };
    },
    mounted() {
      if (!this.user) {
        this.$router.push("/login");
        return;
      }
      this.getUserStocks();
    },
    methods: {
      changePassword() {
        if (!(this.confirmNewPassword && this.newPassword && this.password)) {
          this.$toasted.show("Enter all the required information", {
            duration: 2000,
            position: "bottom-right"
          });
          return;
        }
        if (this.confirmNewPassword !== this.newPassword) {
          this.$toasted.show("Passwords don't match", {
            duration: 2000,
            position: "bottom-right"
          });
          return;
        }
        lb.post("/api/GWSUsers/change-password", {
          oldPassword: this.password,
          newPassword: this.newPassword
        })
          .then(() => {
            this.$toasted.show("Password changed successfully", {
              duration: 2000,
              position: "bottom-right"
            });
            this.openChangePassword = false;
          })
          .catch(e => {
            this.$toasted.show("Oops some error occurred !", {
              position: "bottom-right",
              duration: 2000
            });
            this.openChangePassword = false;
          });
      },
      logout() {
        lb.post("/api/GWSUsers/logout")
          .then(() => {
            this.$router.push("/");
            window.localStorage.removeItem("user");
            window.localStorage.removeItem("accesstoken");
            this.$store.commit("SET_ACCESS_TOKEN", null);
            this.$store.commit("SET_CURRENT_USER", null);
          })
          .catch(e => {
            this.$toasted.show("Oops some error occurred !", {
              position: "bottom-right",
              duration: 2000
            });
            this.$router.push("/");
          });
      },
      beautifyDate(date) {
        return date ? new Date(date).toLocaleDateString() : "N/A";
      },
      getUserStocks() {
        lb.post("/api/GWSUsers/getuserstock", { id: this.user.id })
          .then(({ data }) => {
            this.noActiveSubscription = data.noActiveSubscription;
            this.stocksList = data.stocks;
            this.userPlan = data.plan;
          })
          .catch(e => {
            this.$toasted.error(e.message, {
              position: "bottom-right",
              duration: 2000
            });
            console.log(e);
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .true {
    color: #31cc9a;
  }
  .false {
    color: #d12121;
  }
  .btn-pricing {
    display: block;
    margin: auto;
    background-color: #31cc9a;
    color: #fff;
    height: 50px;
    width: 100%;
    font-weight: 700;
    margin-top: 30px;
  }
  td {
    margin: 5px;
    padding: 3px;
  }
  .myaccountfullPage {
    margin-top: 10vh;
    min-height: 80vh;
  }
  .stock_card {
    .index {
      color: #31cc9a;
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
    }
    .download_report {
      position: absolute;
      bottom: 40px;
    }
    min-height: 200px;
    p {
      line-height: 10px;
    }
  }

  button {
    width: 80%;
    color: #fff;
    font-weight: 800;
    background: #31cc9a;
  }
  .btn_custom {
    background-color: #31cc9a !important;
    color: #fff !important;
    font-weight: 600;
    margin: auto;
    height: 50px;
  }
  @media screen and (max-width: 1024px) {
    .stock_card {
      h4 {
        font-size: px;
      }
      p {
        font-size: 10px;
        line-height: 10px;
      }
    }
    .stock_card .download_report {
      position: absolute;
      bottom: 18%;
      font-size: 12px;
    }
  }
  @media screen and (max-width: 480px) {
    .myaccountfullPage {
      margin-top: 3vh;
      min-height: 80vh;
      h2 {
        font-size: 22px;
      }
    }
    .stock_card .download_report {
      position: absolute;
      bottom: 18%;
    }
    .btn-pricing {
      margin-bottom: 20vh;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/MyAccount.vue